// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

// XNG-Change: custom api for sending for more than one recipient and adding Pricing and Inventory.
export interface XngTellAFriendModelApiParameter
    extends ApiParameter,
        Omit<TellAFriendModel, "friendsName" | "friendsEmailAddress"> {
    friendsEmailAddress?: string[] | string;
    includePricing?: boolean;
    includeInventory?: boolean;
}

const tellAFreiendUrl = "api/pls/Email/tellafriend";

export function xngTellAFriend(parameter: XngTellAFriendModelApiParameter) {
    return post<XngTellAFriendModelApiParameter>(`${tellAFreiendUrl}`, parameter);
}
